import { render } from "./MainParkPage.vue?vue&type=template&id=33848af8&scoped=true"
import script from "./MainParkPage.vue?vue&type=script&lang=js"
export * from "./MainParkPage.vue?vue&type=script&lang=js"

import "./MainParkPage.vue?vue&type=style&index=0&id=33848af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33848af8"]])

export default __exports__